import React from 'react';
import styled from 'styled-components';

import MetaTags from 'components/meta-tags';
import { SignupContent } from 'components/signup-content';
import { useModals, ModalNames } from 'components/modals';

export function EnterpriseSignupContent(): JSX.Element {
  const { openModal } = useModals();
  return (
    <>
      <MetaTags title='enterprise.signup.title' description='enterprise.signup.description' />

      <SignupContainer>
        <SignupWrapper>
          <SignupHeader>
            <SignupTitle>Almost there! Set up your account</SignupTitle>
            <SignupSubtitle>Choose how you would like to sign up and start earning rewards today!</SignupSubtitle>
          </SignupHeader>

          <SignupContent
            redirectUrl={typeof window !== 'undefined' ? window.location.href : ''}
            analyticsEventLabel='enterprise-signup'
          />

          <SignupFooter>
            <FooterText>
              Already have an account?{' '}
              <FooterLink
                as='button'
                type='button'
                onClick={() => openModal(ModalNames.login)}
                data-testid='enterprise-signup-sign-in-link'
              >
                Sign in
              </FooterLink>
            </FooterText>
          </SignupFooter>
        </SignupWrapper>
      </SignupContainer>
    </>
  );
}

// Styled Components for Enterprise Signup Content
const SignupContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb;
  padding: 1rem;
`;

const SignupWrapper = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  width: 100%;
  max-width: 500px;
`;

const SignupHeader = styled.div`
  text-align: center;
  margin-bottom: 1.5rem;
`;

const SignupTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.5rem 0;
`;

const SignupSubtitle = styled.p`
  color: #6b7280;
  margin: 0 0 1rem 0;
`;

const SignupFooter = styled.div`
  margin-top: 2rem;
  text-align: center;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
`;

const FooterText = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
`;

const FooterLink = styled.a`
  color: #3b82f6;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
